export function heroSlider() {
    const $window = $(window);
    const body = this.body;
    const sliderWrap = $('.hero-slider-wrap');
    const title = sliderWrap.find('.title');
    const buttonScroll = sliderWrap.find('.button-scroll');
    const slider = $('.hero-slider');
    const slides = slider.find('.image').length;
    const startSlide = Math.round(slides / 2) - 1;
    let loadCounter = localStorage.getItem('animationStop');
    const isDesktop = !this.isTouch;
    let top = $window.scrollTop();



    function resetAlignImages() {
        slider.find('.slick-slide').each((i, el) => {
            $(el).find('img').css('padding-top', 0)
        });
    }

    function alignImagesToBottom() {
        slider.find('.slick-slide').each((i, el) => {
            const imageWrap = $(el);
            const imageWrapHeight = Math.floor(imageWrap.innerHeight());
            const image = imageWrap.find('img');
            const imgHeight = Math.ceil(image.innerHeight());
            const indent = imageWrapHeight - imgHeight;

            image.css('padding-top', indent);
        });
    }

    function startSlider() {
        slider.on('init', function () {
            if ($window.width() >= 1200) {
                setTimeout(() => {
                    slider.addClass('loaded');
                    alignImagesToBottom();
                }, 200);
            }
        });

        slider.slick({
            draggable: false,
            arrows: false,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 1500,
            infinite: true,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        autoplay: true,
                        autoplaySpeed: 1500,
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 9999,
                    settings: {
                        initialSlide: startSlide,
                        autoplay: false,
                        speed: 1800,
                        infinite: false,
                        slidesToShow: 6
                    }
                }
            ]
        }).on('afterChange', function () {
            if ($window.width() >= 1200) {
                setTimeout(() => {
                    alignImagesToBottom();
                    slider.css('transform', 'translateX(41vw)');
                }, 1000);

                setTimeout(() => {
                    title.addClass('visible');
                    slider.addClass('align-bottom');
                    buttonScroll.addClass('visible');
                }, 2000);

                setTimeout(() => {
                    body.css('overflow', 'visible');
                }, 2500);
            }
        });


        if ($window.width() >= 1200) {
            setTimeout(() => {
                slider.addClass('inited');
                resetAlignImages();
                slider.slick('slickGoTo', 0);
            }, 2000);
        }
    }


    $window.on("load", function() {
        if (loadCounter === null) {
            loadCounter = 0;
        }
        if (loadCounter === 0) {
            loadCounter++;
            localStorage.setItem("animationStop", loadCounter);
            startSlider();
        } else {
            slider.slick({
                draggable: false,
                arrows: false,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 1500,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            autoplay: true,
                            autoplaySpeed: 1500,
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 9999,
                        settings: {
                            autoplay: false,
                            speed: 1800,
                            infinite: false,
                            slidesToShow: 6
                        }
                    }
                ]
            });
            if ($window.width() >= 1200) {
                body.addClass("no-slider-animation");
                slider.addClass('align-bottom');
                slider.css('transform', 'translateX(41vw)');
                slider.addClass('loaded');
                setTimeout(function () {
                    title.addClass('visible');
                    buttonScroll.addClass('visible');
                }, 700);
            }
        }
        if ($window.width() >= 1200 && $window.scrollTop() <= 0 && !body.hasClass("no-slider-animation")) {
            body.css('overflow', 'hidden');
        }
    });
    $window.on("scroll", function() {});


    $window.on("resize", () => {
        if ($window.width() >= 1200 && !slider.hasClass('loaded')) {
            $window.location.reload();
        }
        if ($window.width < 1200) {
            slider.removeClass('loaded');
            body.css('overflow', 'visible');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hero-slider.js